// Angular imports
import { Component, Input, OnInit } from '@angular/core';

// Service imports
import { AuthService } from '../../_services/auth.service';
import { UserService } from '../../_services/data-services/user.service';
import { ScreenService } from '../../_services/shared-services/screen.service';
import { InformationService } from '../../accounts-module/_services/data-services/information.service';

// Model imports
import { UserInfoResultDto } from '../../_models/user-info-result-dto';
import { UserPropertyResultDto } from '../../_models/user-property-result-dto';
import { BaseResidentParameterDto } from '../../_models/base-resident-parameter-dto';

// CC-Common imports
import { RxjsUtils } from '@therealmanage/ciranet-ui-common';

@Component({
  selector: 'app-user-panel',
  templateUrl: 'user-panel.component.html',
  styleUrls: ['./user-panel.component.scss'],
  standalone: false
})
export class UserPanelComponent implements OnInit {
  @Input() menuItems: any;
  @Input() menuMode: string;

  currentUserID: string;
  userInfo: UserInfoResultDto;
  displayName: string;
  isSmallScreen: boolean;
  screenSize: string;
  menuButtonWidth: string;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private screenService: ScreenService,
    private informationService: InformationService
  ) {
    this.userInfo = this.userService.getCurrentUserInfo();
    this.displayName = this.userInfo?.displayName;
    this.updateScreenSize();
  }

  ngOnInit(): void {
    RxjsUtils.safeSubscribe(this.screenService.changed, () =>
      this.updateScreenSize()
    );

    // when refreshing
    this.userInfo = this.userService.getCurrentUserInfo();
    this.populateCurrentUserId();
    this.updateDisplayName();
    RxjsUtils.subscribeToSubject(
      this.authService.getSubjectLoginSuccess(),
      (flag: boolean) => {
        if (flag === true) {
          this.userInfo = this.userService.getCurrentUserInfo();
          this.populateCurrentUserId(); //after login
          this.updateDisplayName();
        }
      }
    );

    RxjsUtils.subscribeToSubject(
      this.authService.getSubjectProfileImageUpdated(),
      (data: any) => {
        //after the user saved a new profile
        this.userInfo.profileImage = data;
      }
    );

    RxjsUtils.subscribeToSubject(
      this.userService.getSubjectImpersonateChanged(),
      (data) => {
        //after impersonatation
        //refresh new user info
        this.userInfo = this.userService.getCurrentUserInfo();
        this.populateCurrentUserId();
        this.updateDisplayName();
      }
    );

    RxjsUtils.subscribeToSubject(
      this.userService.getSubjectPropertySelectionChanged(),
      (userProperty: UserPropertyResultDto) => {
        this.updateDisplayName();
      }
    );
  }

  private populateCurrentUserId(): void {
    if (this.userInfo !== null) {
      this.currentUserID = this.userInfo.displayName;
    }
  }

  private updateDisplayName(): void {
    const selectedProperty = this.userService.getSelectedProperty();
    if (selectedProperty?.customerId && selectedProperty?.communityId) {
      const param = new BaseResidentParameterDto(
        selectedProperty.customerId,
        selectedProperty.communityId
      );
      RxjsUtils.safeSubscribe(
        this.informationService.getContactInformation(param),
        (result) => {
          if (result?.contacts?.length > 0) {
            this.displayName = result.contacts[0].name;
          } else {
            this.displayName = this.userInfo?.displayName;
          }
        },
        () => {
          this.displayName = this.userInfo?.displayName;
        }
      );
    } else {
      this.displayName = this.userInfo?.displayName;
    }
  }

  private updateScreenSize(): void {
    this.screenSize = this.screenService.getCurrentScreenSize;
    this.isSmallScreen =
      this.screenService.isSmallScreen() || this.screenService.isMediumScreen();
    const screenParams = this.screenService.getScreenParams(
      this.screenSize
    ).userpanel;
    this.menuButtonWidth = screenParams.menuButtonWidth;
  }
}
